import { BasePhaseModel } from './BasePhaseModel';
import { IPhase, PhaseType } from '../types';

export interface MapPhaseData {
  address?: string;
  viewport?: {
    lat: number;
    lng: number;
    zoom: number;
  };
  planId?: string;
  mapResultId?: string;
  coordinates?: [number, number];
  rotation?: number;
  stage?: 'map' | 'plan';
  notes?: string;
}

export class MapPhaseModel extends BasePhaseModel<MapPhaseData> {
  constructor(phase: IPhase<MapPhaseData>) {
    super(phase.type === PhaseType.MAP ? phase : { ...phase, type: PhaseType.MAP });
  }

  updateData(data: Partial<MapPhaseData>): IPhase<MapPhaseData> {
    return super.updateData({ ...(this.phase.data || {}), ...data });
  }

  setViewport(viewport: MapPhaseData['viewport']): IPhase<MapPhaseData> {
    return this.updateData({ viewport });
  }

  setAddress(address: string): IPhase<MapPhaseData> {
    return this.updateData({ address });
  }
}
